export default __webpack_public_path__ + "34a872df6462dfc9b4ad54d4712858e3.webp";